type MinimumBrandModal = {
    deleted_at: number | null;
};

export const isAllowArchiveBrand = <Brand extends MinimumBrandModal>(brand: Brand): boolean => {
    return brand.deleted_at === null;
};
